import { render } from "./MyProperties.vue?vue&type=template&id=4303f3ac"
import script from "./MyProperties.vue?vue&type=script&lang=js"
export * from "./MyProperties.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__